import { render, staticRenderFns } from "./InvoiceScanningView.vue?vue&type=template&id=adfc6c10&scoped=true"
import script from "./InvoiceScanningView.vue?vue&type=script&lang=js"
export * from "./InvoiceScanningView.vue?vue&type=script&lang=js"
import "./InvoiceScanningView.vue?vue&type=style&index=0&id=adfc6c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfc6c10",
  null
  
)

export default component.exports